import { t } from 'i18next';
import { filter } from 'lodash';
import { useSelector } from 'react-redux';
import { checkboxGroups } from 'src/constants/userRights.constants';
import { UserEventAndRoleFormType } from 'src/types/services/user-service.type';

export type UserRoleType = { id: string; abbreviation: string };
export type EventType = { eventId: string };

export interface Item {
  id: string;
  userName: string;
  name: string;
  surname: string;
  email: string;
  telephone: string;
  organization: string;
  // userRoleForEvent: UserEventAndRoleFormType[];
  userRoles: UserRoleType[]; // Ontology
  events: EventType[]; // Event
}

export interface UserPropsType {
  activeKey: string;
  defaultKey: string;
}

export const deleteConfirmTitles = () => ({
  title: t('general.deleteConfirmTitle'),
  okText: t('general.no'),
  cancelText: t('general.yes'),
});

export const getRolesList = (userList: any, ontologies: any) => {
  if (!userList) return;
  const filterList: { text: string; value: string }[] = [];
  ontologies
    .filter((f: { ontologyType: number; abbreviation: string }) => f.ontologyType === 5 && f.abbreviation !== 'Root')
    ?.map((g: { abbreviation: any }) => {
      if (filterList.some((i) => i.text === g.abbreviation)) {
        return;
      }

      filterList.push({
        text: g.abbreviation,
        value: g.abbreviation,
      });
    });

  return filterList;
};
